<script setup lang="ts">
import PageIcon from "~/components/dumb/PageIcon.vue";
import { convertToMarkdown, convertToPlainText } from "~/components/text/transformers";
import type { Skill } from "~/shared/types";

defineProps<{
  skill: Skill;
  truncate?: boolean;
}>();
</script>

<template>
  <div class="flex items-center gap-3" :class="{ truncate, 'p-2': !truncate }">
    <PageIcon :page="skill" />
    <div class="flex min-w-0 flex-col" :class="{ truncate }">
      <span class="truncate text-sm font-medium text-md">{{ skill.title }}</span>
      <span
        class="w-full max-w-full min-w-0 overflow-hidden text-xs text-vlt"
        :class="truncate ? 'line-clamp-1 truncate' : 'line-clamp-6'">
        {{ convertToPlainText(convertToMarkdown(skill.prompt)) }}
      </span>
    </div>
  </div>
</template>
